var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-list" },
    [
      _c("el-card", [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.searchForm },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "客户名称" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "请输入客户名称" },
                      model: {
                        value: _vm.searchForm.custName,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "custName", $$v)
                        },
                        expression: "searchForm.custName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "客户地址" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "请输入客户地址" },
                      model: {
                        value: _vm.searchForm.custAddress,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "custAddress", $$v)
                        },
                        expression: "searchForm.custAddress",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "合同号" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "请输入合同号" },
                      model: {
                        value: _vm.searchForm.contractNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "contractNo", $$v)
                        },
                        expression: "searchForm.contractNo",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "预约安装日期" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "150px" },
                      attrs: {
                        type: "date",
                        placeholder: "选择日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.searchForm.scheduledDeliveryDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "scheduledDeliveryDate", $$v)
                        },
                        expression: "searchForm.scheduledDeliveryDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSearch },
                      },
                      [
                        _c("i", { staticClass: "el-icon-search" }),
                        _vm._v(" 搜索\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      { attrs: { plain: "" }, on: { click: _vm.resetSearch } },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "batch-actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleBatchInstall },
                  },
                  [_vm._v("批量安装")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { plain: "" }, on: { click: _vm.handleExpandAll } },
                  [_vm._v("全部展开")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { plain: "" },
                    on: { click: _vm.handleCollapseAll },
                  },
                  [_vm._v("全部折叠")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "text",
                      icon: "el-icon-download",
                      loading: _vm.exportLoading,
                    },
                    on: { click: _vm.handleExport },
                  },
                  [_vm._v("导出")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "divider-line" }),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              attrs: {
                "element-loading-text": "加载订单数据中...",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0.85)",
              },
            },
            [
              !_vm.tableLoading
                ? [
                    _c(
                      "el-table",
                      {
                        ref: "contractTable",
                        staticStyle: {
                          width: "100%",
                          "margin-bottom": "20px",
                          "font-size": "16px",
                        },
                        attrs: {
                          data: _vm.contractList,
                          "max-height": _vm.tableHeight,
                          "header-cell-style": {
                            backgroundColor: "#e8eaed",
                            color: "#333",
                            fontWeight: "bold",
                          },
                          "cell-style": {
                            paddingBottom: "8px",
                            paddingTop: "8px",
                          },
                          border: "",
                          "row-key": "contractId",
                          type: "expand",
                        },
                        on: {
                          "selection-change": _vm.handleContractSelectionChange,
                          "row-click": _vm.handleContractRowClick,
                          "expand-change": _vm.handleContractExpandChange,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            width: "50",
                            "reserve-selection": true,
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { type: "expand" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.designSchemes &&
                                    scope.row.designSchemes.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-left": "20px",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-table",
                                              {
                                                ref:
                                                  "designTable_" +
                                                  scope.row.contractId,
                                                staticStyle: {
                                                  width: "calc(100% - 20px)",
                                                  "font-size": "14px",
                                                },
                                                attrs: {
                                                  data: scope.row.designSchemes,
                                                  size: "small",
                                                  "header-cell-style": {
                                                    backgroundColor: "#e8eaed",
                                                    color: "#333",
                                                    fontWeight: "bold",
                                                  },
                                                  border: "",
                                                  "row-key": "_rowKey",
                                                  type: "expand",
                                                },
                                                on: {
                                                  "selection-change":
                                                    _vm.handleDesignSchemeSelectionChange,
                                                  "row-click":
                                                    _vm.handleDesignSchemeRowClick,
                                                  "expand-change":
                                                    _vm.handleDesignSchemeExpandChange,
                                                },
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    type: "selection",
                                                    width: "50",
                                                    "reserve-selection": true,
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: { type: "expand" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (
                                                          designScope
                                                        ) {
                                                          return [
                                                            designScope.row
                                                              .orderSolutions &&
                                                            designScope.row
                                                              .orderSolutions
                                                              .length > 0
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "margin-left":
                                                                          "20px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-table",
                                                                      {
                                                                        ref:
                                                                          "solutionTable_" +
                                                                          designScope
                                                                            .row
                                                                            ._contractId +
                                                                          "_" +
                                                                          designScope
                                                                            .row
                                                                            .id,
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "100%",
                                                                            "font-size":
                                                                              "13px",
                                                                          },
                                                                        attrs: {
                                                                          data: designScope
                                                                            .row
                                                                            .orderSolutions,
                                                                          size: "small",
                                                                          "header-cell-style":
                                                                            {
                                                                              backgroundColor:
                                                                                "#e8eaed",
                                                                              color:
                                                                                "#333",
                                                                              fontWeight:
                                                                                "bold",
                                                                            },
                                                                          "cell-style":
                                                                            {
                                                                              backgroundColor:
                                                                                "#FFF",
                                                                            },
                                                                          border:
                                                                            "",
                                                                          "row-key":
                                                                            "_rowKey",
                                                                        },
                                                                        on: {
                                                                          "selection-change":
                                                                            _vm.handleOrderSolutionSelectionChange,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "el-table-column",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                type: "selection",
                                                                                width:
                                                                                  "50",
                                                                                "reserve-selection": true,
                                                                              },
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-table-column",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                prop: "solutionName",
                                                                                label:
                                                                                  "生产分类",
                                                                                "min-width":
                                                                                  "120",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-table-column",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                prop: "packages",
                                                                                label:
                                                                                  "包数",
                                                                                "min-width":
                                                                                  "80",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-table-column",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                prop: "area",
                                                                                label:
                                                                                  "面积",
                                                                                "min-width":
                                                                                  "80",
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "default",
                                                                                    fn: function (
                                                                                      sRow
                                                                                    ) {
                                                                                      return [
                                                                                        _c(
                                                                                          "span",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                sRow
                                                                                                  .row
                                                                                                  .area ||
                                                                                                  0
                                                                                              ) +
                                                                                                " m²"
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                true
                                                                              ),
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        color:
                                                                          "#909399",
                                                                        "text-align":
                                                                          "center",
                                                                        padding:
                                                                          "20px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "暂无订单方案"
                                                                    ),
                                                                  ]
                                                                ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "productionOrder",
                                                    label: "销售单号",
                                                    "min-width": "140",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "总包数量",
                                                    "min-width": "140",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (dRow) {
                                                          return [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getDesignSchemeTotalPackages(
                                                                    dRow.row
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              color: "#909399",
                                              "text-align": "center",
                                            },
                                          },
                                          [_vm._v("暂无设计方案")]
                                        ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2718883146
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "contractNumber",
                            label: "合同号",
                            "min-width": "180",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "custName",
                            label: "客户名称",
                            "min-width": "120",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "custMobile",
                            label: "客户手机",
                            "min-width": "120",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "custAddress",
                            label: "客户地址",
                            "min-width": "180",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "contractStatusEnumeration",
                            label: "状态",
                            "min-width": "100",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (row) {
                                  return [
                                    _c("el-tag", { attrs: { size: "mini" } }, [
                                      _vm._v(
                                        _vm._s(
                                          row.row.contractStatusEnumeration ||
                                            "未知"
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            257123238
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "统计",
                            "min-width": "120",
                            align: "left",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-tag",
                                      { attrs: { type: "info", size: "mini" } },
                                      [
                                        _vm._v(
                                          "总包数: " +
                                            _vm._s(
                                              _vm.getContractTotalPackages(
                                                scope.row
                                              )
                                            )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-tag",
                                      {
                                        staticStyle: { "margin-left": "6px" },
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "总方数: " +
                                            _vm._s(
                                              _vm
                                                .getContractTotalArea(scope.row)
                                                .toFixed(2)
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3589546963
                          ),
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "page-sizes": [10, 20, 50, 100],
                "page-size": _vm.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "图片预览",
            visible: _vm.previewImageVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewImageVisible = $event
            },
          },
        },
        [
          _c("img", {
            staticClass: "full-image",
            attrs: { src: _vm.previewImageUrl },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }